import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  removeNullAndUndefinedPropertiesFromJson(obj: string): string {
    if (!obj || typeof obj !== 'string') {
      return obj;
    }
    const parsedObj = JSON.parse(obj);
    const result = this.removeNullAndUndefinedPropertiesFromObject(parsedObj);
    return JSON.stringify(result);
  }

  removeNullAndUndefinedPropertiesFromObject<T = any>(obj: T): T {
    obj = obj || {} as T;
    const copy = {...obj};
    for (const key in copy) {
      if (Object.prototype.hasOwnProperty.call(copy, key)) {
        const propVal: any = copy[key];
        
        if(propVal === null || propVal === undefined || propVal === 'undefined' || propVal === 'null') {
          delete obj[key];
        }
      }
    }

    return obj;
  }
}
